import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { SUPPLIER_PUBLIC_WIDGET_PATH } from './routes';
import PublicSupplierWidgetPage from './app/pages/PublicSupplierWidgetPage';

// The compact widget is the only FreeSupplier-owned public renderer. The full
// page is canonical PublicCatalogSharePage at /public/cbam-portal/:slug.
const SupplierPublicRoutes = () => (
  <Switch>
    <Route
      path={SUPPLIER_PUBLIC_WIDGET_PATH}
      exact
      component={PublicSupplierWidgetPage}
    />
  </Switch>
);

export default SupplierPublicRoutes;
